import React from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import { jobWidgets } from "../../common/data/dashboardJobs";
import DashboardCharts from "./DashboardCharts";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

const Widgets = () => {
  const { t } = useTranslation();

  const { Documents, Laws } = useSelector(state => ({
    Documents: state.DashboardEcommerce.documentData || [],
    Laws: state.DashboardEcommerce.lawData || [],
  }));

  return (
    <React.Fragment>
      <Col xl={12}>
        <div className="d-flex flex-column h-100">
          <Row>
            { Documents?.map((document, key) => (
              <Col xl={3} md={3} key={key}>
                <Card className="card-animate overflow-hidden">
                  <div
                    className="position-absolute start-0"
                    style={{ zIndex: "0" }}
                  >
                    <svg
                      version="1.2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 200 120"
                      width="200"
                      height="120"
                    >
                      <path
                        id="Shape 8"
                        style={{ opacity: ".05", fill: "rgb(11 152 93)" }}
                        d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                      />
                    </svg>
                  </div>
                  <CardBody style={{ zIndex: "1" }}>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                          {" "}
                          {t(document.Label)}
                        </p>
                        <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                          <span className="counter-value" data-target="36894">
                            {document.Count}
                          </span>
                        </h4>
                      </div>
                      <div className="flex-shrink-0">
                        <DashboardCharts
                          seriesData={document.Series}
                          colors={document.Color}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="row">
            {Laws.map((item, idx) => (
                <div className="col-lg-3" key={idx}>
                    <div className="card">
                        <div className="card-body d-flex gap-3 align-items-center">
                            <div className="avatar-sm">
                                <div className={`avatar-title border bg-${item.BgColor}-subtle border-${item.BgColor} border-opacity-25 rounded-2 fs-17`}>
                                    <FeatherIcon icon={item.Icon} className={`icon-dual-${item.BgColor}`}></FeatherIcon>
                                </div>
                            </div>
                            <div className="flex-grow-1">
                                <h5 className="fs-15">{item.Count}</h5>
                                <p className="mb-0 text-muted">{t(item.Label)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

export default Widgets;
